/* @ngInject */
export default class ProjectFilterController {
    constructor(projects, activeProjects, excludedProjects, filterMode, onUpdate, onClose) {
        this.projects = projects;
        this.activeProjects = activeProjects || [];
        this.excludedProjects = excludedProjects || [];
        this.filterMode = filterMode || 'include'; // 'include' or 'exclude'
        this.onUpdate = onUpdate;
        this.onClose = onClose;
        
        // Initialize search query
        this.searchQuery = '';
        
        // Initialize project states based on current filter
        this.projectStates = {};
        this.projects.forEach(project => {
            if (this.filterMode === 'include') {
                this.projectStates[project.id] = this.activeProjects.includes(project.id);
            } else {
                this.projectStates[project.id] = !this.excludedProjects.includes(project.id);
            }
        });
    }
    
    getFilteredProjects() {
        if (!this.searchQuery || this.searchQuery.trim() === '') {
            return this.projects;
        }
        
        const query = this.searchQuery.toLowerCase();
        return this.projects.filter(project => {
            const displayName = (project.displayName || '').toLowerCase();
            const name = (project.name || '').toLowerCase();
            const id = (project.id || '').toLowerCase();
            return displayName.includes(query) || name.includes(query) || id.includes(query);
        });
    }

    toggleProject(projectId) {
        this.projectStates[projectId] = !this.projectStates[projectId];
    }

    toggleFilterMode() {
        this.filterMode = this.filterMode === 'include' ? 'exclude' : 'include';
        
        // When switching modes, invert all selections
        Object.keys(this.projectStates).forEach(projectId => {
            this.projectStates[projectId] = !this.projectStates[projectId];
        });
    }

    clear() {
        // Clear all selections
        Object.keys(this.projectStates).forEach(projectId => {
            this.projectStates[projectId] = false;
        });
        this.apply();
    }

    apply() {
        const activeProjects = [];
        const excludedProjects = [];
        
        Object.keys(this.projectStates).forEach(projectId => {
            if (this.filterMode === 'include') {
                if (this.projectStates[projectId]) {
                    activeProjects.push(projectId);
                }
            } else if (!this.projectStates[projectId]) {
                excludedProjects.push(projectId);
            }
        });
        
        this.onUpdate({
            mode: this.filterMode,
            activeProjects,
            excludedProjects
        });
        this.onClose();
    }

    getSelectedCount() {
        return Object.values(this.projectStates).filter(state => state).length;
    }

    getTotalCount() {
        return this.projects.length;
    }
}

